<div class="container">
  <div class="row">
    <div class="col-lg-10 col-xl-8 mx-auto">
      <div class="card flex-row my-5 border-0 shadow rounded-5 overflow-hidden">
        <div class="card-body p-4 p-sm-5">
          <div class="d-flex justify-content-between mb-3">
            <img src="./assets/identity/logo.png" style="width: 20%;">
            <h5 class="pt-4">{{'create-user' |translate}} | <label *ngIf="passwordStepper === 1" class="color-darkgoldenrod">{{'username'| translate}}</label><label class="color-darkgoldenrod" *ngIf="passwordStepper === 2">{{'first-password'| translate}}</label><label class="color-darkgoldenrod" *ngIf="passwordStepper === 3">{{'second-password'| translate}}</label>
            </h5>
          </div>
          <hr>
          <div class="form-access my-auto">
            <form [formGroup]="resetPassWordForm">
              <div class="form-input">
                <div class='row' *ngIf="passwordStepper === 1">
                  <div class="col-md-6">
                    <div class="form-group d-flex flex-column align-items-start rowUser">
                      <span class="mb-2" [ngClass]="resetPassWordForm.controls['userName'].invalid && resetPassWordForm.controls['userName'].touched && resetPassWordForm.controls['userName'].dirty ? 'text-danger' : ''">{{'username'|translate}}</span>
                      <input type="text" class="form-control" formControlName="userName" (keyup)="removeErrorMsg()" [ngClass]="resetPassWordForm.controls['userName'].invalid && resetPassWordForm.controls['userName'].touched || (resetPassWordForm.controls['userName'].invalid && resetPassWordForm.controls['userName'].dirty) ? 'is-invalid' : ''">
                      <label class="text-danger text-start" *ngIf="resetPassWordForm.controls['userName'].hasError('required') && resetPassWordForm.controls['userName'].dirty">
                        {{'username-required'|translate}}
                      </label>    
                      <label class="text-danger text-start" *ngIf="isDuplicateUserName && resetPassWordForm.controls['userName'].dirty && resetPassWordForm.controls['userName'].value!=''">
                        {{'duplicate-username'|translate}}
                      </label> 
                      <label class="text-danger text-start" *ngIf="resetPassWordForm.controls['userName'].invalid && resetPassWordForm.controls['userName'].dirty && resetPassWordForm.controls['userName'].value!=''">
                        {{'invalid-username'|translate}}
                      </label> 
                      <button type="button" [ngClass]="{'disable': resetPassWordForm.controls['userName'].invalid}" [disabled]="resetPassWordForm.controls['userName'].invalid " (click)="next()" class="btn btn-primary m-2">{{'next'|translate}} <i [ngClass]="lang == 'ar'? 'fas fa-arrow-left' : 'fas fa-arrow-right'"></i></button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <img src="../../../assets/img/create-user.svg" class="create-img" alt="">
                  </div>
                </div>
                <div *ngIf="passwordStepper === 2">
                  <div class="d-flex justify-content-between">
                    <div class="col-7">
                      <br>
                      <div class="form-group pl-3 text-start">
                        <label class="mb-2 ">{{'new-password' |translate}}</label>
                        <div class="input-group">
                          <input [type]="showPassword1 ? 'text' : 'password'" class="form-control" formControlName="firstNewPassword" [ngClass]="resetPassWordForm.controls['firstNewPassword'].invalid && resetPassWordForm.controls['firstNewPassword'].touched ? 'is-invalid' : ''">
                          <div class="input-group-prepend">
                            <i *ngIf="!showPassword1" (click)="showPassword1 = !showPassword1" class="fas fa-eye input-group-text"></i>
                            <i *ngIf="showPassword1" (click)="showPassword1 = !showPassword1" class="fas fa-eye-slash input-group-text"></i>
                          </div>
                        </div>
                        <label class="text-danger" *ngIf="resetPassWordForm.controls['firstNewPassword'].hasError('required') && resetPassWordForm.controls['firstNewPassword'].touched">
                          {{'password-required'|translate}}
                        </label>
                      </div>
                      <div class="form-group pl-3 text-start">
                        <label class="mb-2">{{'re-password' |translate}}</label>
                        <div class="input-group">
                          <input [type]="showPassword2 ? 'text' : 'password'" [ngClass]="resetPassWordForm.controls['reFirstNewPassword'].invalid && resetPassWordForm.controls['reFirstNewPassword'].touched ? 'is-invalid' : ''" class="form-control" formControlName="reFirstNewPassword">
                          <div class="input-group-prepend">
                            <i *ngIf="!showPassword2" (click)="showPassword2 = !showPassword2" class="fas fa-eye input-group-text"></i>
                            <i *ngIf="showPassword2" (click)="showPassword2 = !showPassword2" class="fas fa-eye-slash input-group-text"></i>
                          </div>
                        </div>
                        <label class="text-danger" *ngIf="resetPassWordForm.controls['reFirstNewPassword'].hasError('required') && resetPassWordForm.controls['reFirstNewPassword'].touched">
                          {{'password-required'|translate}}
                        </label>
                        <label class="text-danger" *ngIf="resetPassWordForm.controls['reFirstNewPassword'].hasError('NoPassswordMatch') && !resetPassWordForm.controls['reFirstNewPassword'].hasError('required')">
                          {{'password-match'| translate}}
                        </label>
                      </div>
                    </div>
                    <div class="multi-validation align-self-center mt-5">
                      <app-password-validation-section [control]="resetPassWordForm.controls['firstNewPassword']"></app-password-validation-section>
                    </div>
                  </div>
                  <br>

                  <div class="d-flex justify-content-between">
                    <button type="button" (click)="back()" [disabled]="passwordStepper <= 1" class="btn btn-primary"><i [ngClass]="lang == 'ar'? 'fas fa-arrow-right' : 'fas fa-arrow-left'"></i> {{'previous'|translate}}</button>
                    <button type="button" [disabled]="resetPassWordForm.controls.firstNewPassword.errors  || resetPassWordForm.controls.reFirstNewPassword.errors" (click)="next()" class="btn btn-primary">{{'next'|translate}} <i [ngClass]="lang == 'ar'? 'fas fa-arrow-left' : 'fas fa-arrow-right'"></i></button>
                  </div>
                </div>

                <div class="row" *ngIf="passwordStepper === 3">
                  <div class="col-md-6">
                    <div class="form-group pl-3 text-start">
                      <label class="mb-2">{{'new-password' |translate}}</label>
                      <div class="input-group">
                        <input [type]="showPassword1 ? 'text' : 'password'" [ngClass]="resetPassWordForm.controls['secondNewPassword'].invalid && resetPassWordForm.controls['secondNewPassword'].touched ? 'is-invalid' : ''" class="form-control" formControlName="secondNewPassword">
                        <div class="input-group-prepend">
                          <i *ngIf="!showPassword1" (click)="showPassword1 = !showPassword1" class="fas fa-eye input-group-text"></i>
                          <i *ngIf="showPassword1" (click)="showPassword1 = !showPassword1" class="fas fa-eye-slash input-group-text"></i>
                        </div>
                      </div>
                      <label class="text-danger" *ngIf="resetPassWordForm.controls['secondNewPassword'].hasError('pattern') && resetPassWordForm.controls['secondNewPassword'].touched">
                        {{'second-password-validation'|translate}}
                      </label>
                      <!-- <label class="text-danger"
                        *ngIf="resetPassWordForm.controls['secondNewPassword'].hasError('required') && resetPassWordForm.controls['secondNewPassword'].touched">
                        {{'password-required'|translate}}
                      </label>
                      <label class="text-danger"
                        *ngIf="resetPassWordForm.controls['secondNewPassword'].hasError('pattern') && resetPassWordForm.controls['secondNewPassword'].touched">
                        {{'numbers-char-only'|translate}}
                      </label>
                      <label class="text-danger"
                        *ngIf="resetPassWordForm.controls['secondNewPassword'].hasError('minlength') && resetPassWordForm.controls['secondNewPassword'].touched">
                        {{'4-char'|translate}}
                      </label>
                      <label class="text-danger"
                        *ngIf="resetPassWordForm.controls['secondNewPassword'].hasError('maxlength') && resetPassWordForm.controls['secondNewPassword'].touched">
                        {{'6-char'|translate}}
                      </label> -->
                    </div>
                    <div class="form-group pl-3 text-start">
                      <label class="mb-2">{{'re-password' |translate}}</label>
                      <div class="input-group">
                        <input [type]="showPassword2 ? 'text' : 'password'" [ngClass]="resetPassWordForm.controls['reSecondNewPassword'].invalid && resetPassWordForm.controls['reSecondNewPassword'].touched ? 'is-invalid' : ''" class="form-control" formControlName="reSecondNewPassword">
                        <div class="input-group-prepend">
                          <i *ngIf="!showPassword2" (click)="showPassword2 = !showPassword2" class="fas fa-eye input-group-text"></i>
                          <i *ngIf="showPassword2" (click)="showPassword2 = !showPassword2" class="fas fa-eye-slash input-group-text"></i>
                        </div>
                      </div>
                      <label class="text-danger" *ngIf="resetPassWordForm.controls['reSecondNewPassword'].hasError('required') && resetPassWordForm.controls['reSecondNewPassword'].touched">
                        {{'password-required'|translate}}
                      </label>
                      <label class="text-danger" *ngIf="resetPassWordForm.controls['reSecondNewPassword'].hasError('pattern') && resetPassWordForm.controls['reSecondNewPassword'].touched">
                        {{'numbers-char-only'|translate}}
                      </label>
                      <label class="text-danger" *ngIf="resetPassWordForm.controls['reSecondNewPassword'].hasError('NoPassswordMatch') && !resetPassWordForm.controls['reSecondNewPassword'].hasError('required')">
                        {{'password-match'| translate}}
                      </label>
                    </div>
                    <br>
                    <div class="d-flex justify-content-between">
                      <button type="button" (click)="back()" class="btn btn-primary"><i [ngClass]="lang == 'ar'? 'fas fa-arrow-right' : 'fas fa-arrow-left'"></i> {{'previous'|translate}}</button>
                      <button type="button" (click)="onSubmit()" [disabled]="resetPassWordForm.invalid || resetPassWordForm.pristine" class="btn btn-primary">{{'submit' |translate}}</button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <img src="../../../assets/img/lock-screen.png" class="create-img" alt="">
                  </div>

                </div>

              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
